import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal__event-category"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "modal__event-subcategory"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.eventMainCategory)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.checkHasTranslation(_ctx.eventCategoryTranslationKey))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_translated_text_component, { translation: _ctx.eventCategoryTranslationKey }, null, 8, ["translation"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.modalData.category && !_ctx.checkHasTranslation(_ctx.modalData.category.event_code))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_translated_text_component, {
                  translation: `EVENT_CATEGORY_NAME_${_ctx.modalData.category.event_code}`
                }, null, 8, ["translation"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.modalData && _ctx.modalData.description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal__description",
          innerHTML: _ctx.modalData.description
        }, null, 8, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.modalData && _ctx.modalData.subcategory)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Kategoria: ", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.modalData.subcategory.name), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}